
  document.addEventListener("DOMContentLoaded", (e) => {
    let imgs = document.querySelectorAll('.image-banner img');
    imgs.forEach(el => {
      el.loading = 'eager';
    })
  });

let s;
let desktop = window.matchMedia("(min-width: 992px)").matches;
let i = desktop ? 'top 45%': 'top 25%';
let b = desktop ? 'bottom 90%': 'bottom 70%';
let actions = desktop ? 'restart reverse none none': 'restart pause resume none';
let n = document.querySelector('.text-anim-section').nextSibling;
let p = document.querySelector('.text-anim-section').previousSibling; 

const display = () => {
  let wrapperPercent = document.querySelector('.text-scale-wrapper').offsetHeight/2.3;
  gsap.set('.text-scale-link', { scale: s, y: -wrapperPercent });

  if (window.matchMedia("(max-width: 991px)").matches) {
    gsap.set('.span-line-1', { xPercent:"0", yPercent : "0", left: "0%" });
    gsap.set('.span-line-2', { xPercent:"0", yPercent : "0", left: "0%" });
  } else {
    gsap.set('.span-line-1', { xPercent:"-50", yPercent : "-50", left: "50%" });
    gsap.set('.span-line-2', { xPercent:"50", yPercent : "50", left: "-50%" });
  }
}

scaleResp();
display();

window.addEventListener("load", (event) => {
  let pageHeight = document.body.scrollHeight;
  const root = document.querySelector(':root');
  const targetSection = document.querySelector('.text-anim-section').offsetTop;
  const sectionHeight = document.querySelector('.text-scale-section').offsetHeight;

  const sectionsAboveTarget = Array.from(document.querySelectorAll('main > section'));

  const firstDivAfterMain = document.querySelector('main section:first-child');
  const targetDiv = document.querySelector('.text-anim-section');

        let totalHeight = 0;
        let shouldInclude = false;

        sectionsAboveTarget.forEach(div => {
            if (!shouldInclude) {
                if (div === firstDivAfterMain) {
                    shouldInclude = true;
                }
            } else {
                if (div === targetDiv) {
                    shouldInclude = false;
                } else {
                    //console.log(div + ' ' + div.offsetHeight);
                    totalHeight += div.querySelector('.image-banner').offsetHeight;
                }
            }
        });

  root.style.setProperty('--anim-height', totalHeight + 'px');
  root.style.setProperty('--section-height', (totalHeight + sectionHeight) + 'px');


  gsap.defaults({ ease: "cubic-bezier(0.83, 0, 0.17, 1)" })
  let tlText = gsap.timeline({
    scrollTrigger: {
      trigger: '.text-scale-block',
      start: i,
      end : b,
      //end: '+=1000',
      //markers: true,
      scrub:true,
      toggleActions: actions,
      onLeave: (self) => {
      },
    }
  });

  if (window.matchMedia("(min-width: 992px)").matches) {
    tlText
    .to('.text-scale-link', {y: 0, duration: 1})
    .to('.span-line-1', {xPercent:"0", left: 0},"-=0.3")
    .to('.span-line-2', {xPercent:"0", left: 0},"<")
    .to('.span-line-1', {yPercent:"0", duration: 0.5},"-=0.2")
    .to('.span-line-2', {yPercent:"0", duration: 0.5},"<")
    .to('.text-scale-link', {scale: 1},"-=0.4")
  } else {
    tlText
    .to('.text-scale-link', {y: 0, duration: 1})
    .to('.text-scale-link', {scale: 1, opacity: 1},"-=0.4")
  }


  //tlScale.to('.text-scale-link', {scale:1, y: 0})

});

window.addEventListener('resize', function(event){
  if (destkop) {
    display();
  }
  scaleResp();
});

function scaleResp() {
  let desktop = window.matchMedia("(min-width: 992px)").matches;

  desktop ? s = 0.3 : s = 0.6;
  return s;
}